<spinner *ngIf="retrieving" messageRelativePosition="bottom"> </spinner>

<table *ngIf="!retrieving" class="adminTable">
  <!--Table head-->
  <thead>
    <tr>
      <!-- Action Links Column -->
      <th *ngIf="isSuperAdmin"></th>

      <th class="sortable-header" (click)="onSetSortClick('title')">
        Title

        <span *ngIf="sort === 'title'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <th class="sortable-header" (click)="onSetSortClick('reservationId')">
        Reservation ID

        <span *ngIf="sort === 'reservationId'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <th class="sortable-header" (click)="onSetSortClick('status')">
        Status

        <span *ngIf="sort === 'status'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <th class="sortable-header" (click)="onSetSortClick('checkInCode')">
        Code In

        <span *ngIf="sort === 'checkInCode'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <th class="sortable-header" (click)="onSetSortClick('checkOutCode')">
        Code Out

        <span *ngIf="sort === 'checkOutCode'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <th class="sortable-header" (click)="onSetSortClick('emailAddress')">
        Name/Email/Phone

        <span *ngIf="sort === 'emailAddress'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <!-- PK of CheckIn table -->
      <th class="sortable-header" (click)="onSetSortClick('checkInId')">
        CheckIn ID

        <span *ngIf="sort === 'checkInId'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>
    </tr>
  </thead>
  <!--Table head-->
  <!--Table body-->
  <tbody *ngIf="rows && !retrieving">
    <tr (click)="onSingleClick($event, r)" (dblclick)="onDoubleClick($event, r)" *ngFor="let r of rows">
      <!-- Action Links Column -->
      <td *ngIf="isSuperAdmin"></td>

      <td>
        <div (click)="onSingleClick(r)">
          {{ r.title }}
        </div>
      </td>

      <td>
        <div (click)="onSingleClick(r)">
          {{ r.reservationId }} <link-to-booking-detail [bookingId]="r.bookingId"></link-to-booking-detail>

          <link-to-new-admin-listing [listingId]="r.listingId"></link-to-new-admin-listing>
        </div>
      </td>

      <td>
        <div (click)="onSingleClick(r)">
          {{ r.status }}
        </div>
      </td>

      <td>
        <div (click)="onSingleClick(r)">
          {{ r.checkInCode }}

          <div
            *ngIf="isSuperAdmin && r && r.checkInCode"
            (click)="onManualCheckIn(r)"
            [ngClass]="{ link: !r.submitting, 'link-disabled': r.submitting }"
          >
            Manual Check In
          </div>
        </div>
      </td>

      <td>
        <div (click)="onSingleClick(r)">
          {{ r.checkOutCode }}

          <div
            *ngIf="isSuperAdmin && r && r.checkOutCode"
            (click)="onManualCheckOut(r)"
            [ngClass]="{ link: !r.submitting, 'link-disabled': r.submitting }"
          >
            Manual Check Out
          </div>
        </div>
      </td>

      <td>
        <div class="email-cell" (click)="onSingleClick(r)">
          <div *ngIf="r.fullName">
            {{ r.fullName }}
          </div>

          <div *ngIf="r.mobilePhone">
            {{ r.mobilePhone }}
          </div>
          <div>
            <span *ngIf="r.emailAddress">{{ r.emailAddress }} </span>
            <link-to-user-account-detail [openInNewTab]="true" [userAccountId]="r.userAccountId"></link-to-user-account-detail>
          </div>
        </div>
      </td>

      <td>
        <div (click)="onSingleClick(r)">
          {{ r.checkInId }}
        </div>
      </td>
    </tr>
  </tbody>
  <!--Table body-->
</table>
